import React, { type PropsWithChildren } from 'react';
import { useTheme } from '@emotion/react';
import { MobileLayout } from '@bbkAdminComponents/experiences/offers/edit-offer-page-context';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';

export const MobileDevicePreview: React.FC<
  PropsWithChildren & { mobileLayout?: MobileLayout }
> = ({ children, mobileLayout = MobileLayout.TAKEOVER_MODAL }) => {
  const theme = useTheme() as EmotionTheme;

  return (
    <div
      className={cs(
        'tw-flex tw-h-[800px] tw-w-[400px] tw-flex-col tw-rounded-[3rem] tw-border-[16px] tw-border-solid tw-border-black',
        {
          'tw-justify-end': mobileLayout === MobileLayout.PARTIAL_MODAL,
        }
      )}
    >
      <div
        className={cs('tw-flex tw-justify-center tw-bg-black/50', {
          [`tw-bg-[${theme.modalBackground}]`]:
            mobileLayout !== MobileLayout.PARTIAL_MODAL,
        })}
      >
        <div className="tw-my-3 tw-h-[30px] tw-w-[110px] tw-rounded-full tw-bg-black" />
      </div>
      <div
        className={cs('tw-w-full tw-bg-black/50', {
          'tw-h-full': mobileLayout === MobileLayout.PARTIAL_MODAL,
        })}
      />
      <div className="tw-flex tw-h-full tw-flex-col">{children}</div>
    </div>
  );
};
